import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from './useUser';
import { getAuthorizationFailureReason } from '../auth/authorization';

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const location = useLocation();
  const { user, profile, loading } = useUser();

  if (loading) return null;

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  const reason = getAuthorizationFailureReason(profile, allowedRoles);
  if (reason) {
    return (
      <Navigate
        to="/unauthorized"
        replace
        state={{ from: location.pathname, reason, role: profile?.role ?? null }}
      />
    );
  }

  return children;
};

export default PrivateRoute;
